export const VIDEO_PROCESSING_POLL_INTERVAL_MS = 10_000;
export const VIDEO_PROCESSING_POLL_TIMEOUT_MS = 5 * 60 * 1000;
